import selectorsGenerator from '../selectorsGenerator'
import assignmentsSelectorsGenerator from '../../usersAssignedToHierarchy/selectorsGenerator'
import {getSingleCPSelection, getTaskCustomFieldsMap} from '../../../taskManagement/common/selectors'
import {getCustomers, getProjects} from '../../../entities/selectors'
import {createSelector} from 'reselect'
import _ from 'underscore'
import {selectTaskCustomFields} from '../../../customFields/selectors'
import {CustomFieldType} from '../../../customFields/constants'

export const getTaskPanelState = state => state.panels.task.create

const taskPanelSelectors = selectorsGenerator(getTaskPanelState)
const assignmentsSelectors = assignmentsSelectorsGenerator(getTaskPanelState)

export const isLoaded = taskPanelSelectors.isLoaded
export const isLoading = taskPanelSelectors.isLoading
export const isPanelOpened = taskPanelSelectors.isPanelOpened
export const isNeedToLoadData = taskPanelSelectors.isNeedToLoadData
export const getTaskStatusId = taskPanelSelectors.getTaskStatusId
export const isTaskCompleted = taskPanelSelectors.isTaskCompleted
export const getTaskDeadline = taskPanelSelectors.getTaskDeadline
export const getTaskName = taskPanelSelectors.getTaskName
export const getEstimatedTime = taskPanelSelectors.getEstimatedTime
export const getTaskDescription = taskPanelSelectors.getTaskDescription
export const getBillingType = taskPanelSelectors.getBillingType
export const getBillableTypeName = taskPanelSelectors.getBillableTypeName
export const isWorkTypeBillable = taskPanelSelectors.isWorkTypeBillable
export const getTaskPanelErrors = taskPanelSelectors.getTaskPanelErrors
export const getTaskBillableTypeId = taskPanelSelectors.getTaskBillableTypeId
export const getTaskInfo = taskPanelSelectors.getTaskInfo

export const getTaskPanelTabKey = taskPanelSelectors.getTaskPanelTabKey
export const getLastTaskPanelTabKey = taskPanelSelectors.getLastTaskPanelTabKey

export const getAssignedUsers = assignmentsSelectors.getAssignedUsers
export const getAssignedManagers = assignmentsSelectors.getAssignedManagers
export const canModifyAnyUser = assignmentsSelectors.canModifyAnyUser
export const canModifyAnyManager = assignmentsSelectors.canModifyAnyManager

export const getAddedAssignedUserIds = (state) => getTaskPanelState(state).addedAssignedUserIds
export const getAddedAssignedManagerIds = (state) => getTaskPanelState(state).addedAssignedManagerIds

export const getDefaultTaskInfoState = (state) => getTaskPanelState(state).taskInfoDefaultState
export const isNeedInitializeFocus = (state) => getTaskPanelState(state).isNeedInitializeFocus
export const getCustomFieldsValues = (state) => getTaskPanelState(state).customFieldsValues

export const getProjectName = createSelector(
    getSingleCPSelection,
    getProjects,
    (selector, projects) => {
        return (projects[selector.projectId]) ? projects[selector.projectId].name : ""
    }
)

export const getCustomerName = createSelector(
    getSingleCPSelection,
    getCustomers,
    (selector, customers) => {
        return (customers[selector.customerId]) ? customers[selector.customerId].name : ""
    }
)

export const isTaskDataChanged = createSelector(
    getDefaultTaskInfoState,
    getTaskInfo,
    getAddedAssignedUserIds,
    getAddedAssignedManagerIds,
    (defaultInfo, curInfo, addedAssignedUsersIds, addedAssignedManagersIds) => {
        return !_.isEqual(defaultInfo, curInfo) ||
               !_.isEmpty(addedAssignedUsersIds) ||
               !_.isEmpty(addedAssignedManagersIds)

    }
)

const getCustomFieldValueOrDefault = (customField, customFieldValue) => {
    if (customFieldValue === undefined) {
        if (customField.type === CustomFieldType.Dropdown) {
            return customField.options.find(option => option.value === customField.defaultValue).value
        }
        return null
    } else {
        return customFieldValue
    }
}

export const getCustomFieldsValuesWithDefaults = createSelector(
    selectTaskCustomFields,
    getCustomFieldsValues,
    (customFields, customFieldsValues) => {
        const result = {}
        customFields.forEach(cf => {
            result[cf.fieldName] = getCustomFieldValueOrDefault(cf, customFieldsValues[cf.fieldName])
        })
        return result
    }
)



// WEBPACK FOOTER //
// ./web/js/panels/task/createPanel/selectors.js